export default __webpack_public_path__ + "static/GeneralMap-72dbf1fbcd63565877b1f2f3fbeac31b.png";